// api/services/assistantService.js
import api from '../client';

export const assistantService = {
  // Send a message to the creator onboarding assistant.
  // history: [{ role: 'user' | 'assistant', content: string }]
  // context: optional { project_id, ... } describing where the user is in the UI.
  sendMessage: async (message, history = [], context = null) => {
    const { data } = await api.post('/assistant/chat/', { message, history, context });
    return data; // { response, metadata, debug_trace }
  },
};

export default assistantService;
